<template>
  <div class="approve-info-message">
    <v-img
      :src="require('../../assets/icons/task.svg')"
      contain
      style="width: 64px; height: 64px;"
    />
    <div>
      <h3>Bilgilerinizi başarıyla aldık!</h3>
      <p v-if="!isApplicationInReview">
        Eğer verdiğin bilgiler doğruysa, onaylamak için 'Onayla' butonuna
        tıklayın. Gerekli incelemelerin ardından, en kısa sürede sizinle
        iletişime geçeceğiz. Teşekkür ederiz!
      </p>
      <p v-if="isApplicationInReview">
        Ekibimiz tarafından yapılacak gerekli incelemelerin ardından, en kısa
        sürede sizinle iletişime geçeceğiz. Teşekkür ederiz!
      </p>
    </div>

    <v-btn
      v-if="!isApplicationInReview"
      class="approve-button"
      @click="updateMerchantFormStatus('PendingApproval')"
    >
      Onayla
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FormApprove',
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData },
      isApplicationInReview: false,
    }
  },
  created() {
    const data = this.getFormData()

    if (
      data.status == 'PendingApproval' ||
      data.status == 'AwaitingStoreOpening'
    ) {
      this.isApplicationInReview = true
    }
  },
  methods: {
    ...mapActions('applyMerchantForm', [
      'putAppliedMerchantStatus',
      'getMerchantApplicationDetailsByEmail',
      'putApplyMerchantForm',
    ]),
    updateMerchantFormStatus(status) {
      this.putApplyMerchantForm(this.formData).then((res) => {
        this.putAppliedMerchantStatus({
          id: this.localData.id,
          status: status,
        }).then((isUpdated) => {
          if (isUpdated) {
            alert('Başarıyla Gönderildi.')
          }
          this.getMerchantApplicationDetailsByEmail().then((res) => {
            if (
              res.status == 'PendingApproval' ||
              res.status == 'AwaitingStoreOpening'
            ) {
              this.isApplicationInReview = true
            }
          })
        })
      })
    },
  },
  computed: {
    ...mapGetters('applyMerchantForm', ['getFormData']),
  },
  mounted() {
    this.getMerchantApplicationDetailsByEmail().then((res) => {
      if (
        res.status == 'PendingApproval' ||
        res.status == 'AwaitingStoreOpening'
      ) {
        this.isApplicationInReview = true
      }
    })
  },
}
</script>
<style>
.approve-info-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
}
.approve-info-message h3 {
  font-size: 26px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 16px;
}
.approve-info-message p {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #667085;
}
.approve-button {
  background-color: #4f3cef !important;
  width: 100%;
  color: white !important;
  border-radius: 24px;
  text-transform: capitalize;
  font-weight: 700;
}
</style>
